import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
  },
  header: {
    position: 'relative',
    padding: '11px 30px',
    background: '#EAEDF2',
    boxShadow: '0px 3px 6px rgba(0, 0, 0, .29)',
  },
  container: {
    display: 'flex',
    flexGrow: 1,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  wrapper: {
    display: 'flex',
    flex: 1,
    overflow: 'hidden',
  },
  box: {
    width: '100%',
    padding: 15,
    [theme.breakpoints.down('xs')]: {
      marginTop: 20,
      padding: 5,
    },
  },
  button: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 'auto',
    padding: '3px 15px',
    background: 'transparent',
    borderRadius: 20,
    cursor: 'pointer',
    '&:hover': {
      background: 'transparent',
    },
  },
  icon: {
    color: theme.custom.darkBlue,
  },
  title: {
    marginLeft: 20,
    fontSize: 24,
    fontFamily: 'NeoSansStd',
    fontWeight: 600,
    lineHeight: 1,
    color: theme.custom.darkBlue,
    textTransform: 'capitalize',
  },
  aside: {
    maxWidth: 300,
    padding: '15px 20px',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'row-reverse',
      justifyContent: 'flex-end',
      maxWidth: '100%',
    },
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
    },
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 20,
    padding: 15,
    borderColor: theme.custom.lightBlue,
    boxShadow: '0px 1px 11px rgba(112, 136, 210, .48)',
    [theme.breakpoints.down('sm')]: {
      marginTop: 0,
      marginRight: 30,
      flex: 1,
    },
    [theme.breakpoints.down('xs')]: {
      marginRight: 0,
      marginTop: 30,
    },
  },
  picker: {
    [theme.breakpoints.down('sm')]: {
      flex: 1,
    },
  },
  cardTitle: {
    display: 'block',
    marginBottom: 15,
    fontSize: 16,
    fontFamily: 'NeoSansStd',
    color: theme.custom.darkBlue,
  },
  cardImg: {
    display: 'block',
    maxWidth: 230,
    maxHeight: 170,
    height: 'auto',
    marginBottom: 15,
  },
  cardPrice: {
    display: 'block',
    marginBottom: 15,
    fontSize: 16,
    color: theme.custom.darkBlue,
  },
  cardDescription: {
    display: 'block',
    fontSize: 14,
    color: theme.custom.darkBlue,
    opacity: 0.7,
  },
  days: {
    display: 'flex',
    height: '100%',
    paddingLeft: 32,
    paddingRight: 32,
    [theme.breakpoints.down('xs')]: {
      minHeight: 350,
      paddingLeft: 25,
      paddingRight: 25,
    },
  },
  day: (props) => ({
    width: `calc(100% / ${(props as any).count})`,
    height: '100%',
  }),
  loadingDay: {
    padding: '0 5px',
  },
  loaderWrapper: (props) => ({
    width: `calc(100% / ${(props as any).count})`,
    padding: 5,
  }),
  skeleton: {
    width: '100%',
    height: '100%',
    transform: 'scale(1, 1)',
    transformOrigin: '0 0',
  },
  ul: (props) => ({
    width: `calc(100% / ${(props as any).count})`,
    margin: 0,
    padding: 5,
    listStyle: 'none',
    [theme.breakpoints.down('xs')]: {
      padding: 2,
    },
  }),
  slot: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: 45,
    marginBottom: 5,
    fontSize: 14,
    fontFamily: 'NeoSansStd',
    fontWeight: 600,
    background: '#fff',
    boxShadow: '0px 3px 6px rgba(112, 136, 210, .34)',
    color: '#347AC4',
    transition: '.05s linear',
    cursor: 'pointer',
    '&:last-child': {
      marginBottom: 0,
    },
    '&:hover': {
      transform: 'scale(1.05)',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 12,
    },
  },
  disabledSlot: {
    opacity: '.5',
    cursor: 'default',
    '&:hover': {
      transform: 'scale(1)',
    },
  },
  cardWrapper: {
    position: 'fixed',
    top: '50%',
    right: 0,
    maxWidth: 300,
    width: '100%',
    transform: 'translateY(-50%)',
  },
  cardRoot: {
    background: theme.custom.darkBlue,
    borderRadius: 0,
  },
  cardInfoContent: {
    fontFamily: 'NeoSansStd',
    color: '#fff',
  },
  cardActions: {
    justifyContent: 'space-between',
  },
  cardInfo: {
    margin: 0,
    padding: 0,
    listStyle: 'none',
  },
  cardInfoItem: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 15,
  },
  cardInfoItemIcon: {
    marginRight: 15,
    fontSize: '1.3rem',
    color: '#fff',
  },
  cardInfoItemText: {
    fontSize: 15,
    color: '#fff',
  },
  closeBtn: {
    background: theme.custom.lightBlue,
  },
  acceptBtn: {
    background: theme.custom.accept,
  },
  cancelBtn: {
    background: theme.custom.warning,
  },
  mock: {
    height: 4,
  },
  progressColorPrimary: {
    background: theme.custom.lightBlue,
  },
  barColorPrimary: {
    background: '#fff',
  },
  disabledBtn: {
    opacity: 0.7,
  },
  imgMock: {
    display: 'block',
    maxWidth: 230,
    height: 170,
    marginBottom: 15,
  },
}));
